module.exports = __webpack_public_path__ + "img/KW.d5114e52.webp";